import { routerSelectors } from '~/selectors';
import { errorMessagesActions, errorTypes } from '~/components';

export const historyErrorState = (store) => (next) => (action) => {
  next(action);

  if (action.type === '@@router/LOCATION_CHANGE') {
    const routerState = routerSelectors.selectLocationErrorState(store.getState());

    if (routerState.isError) {
      next(errorMessagesActions.resetErrorMessagesWith([{ type: routerState.type }]));
    }
    if (!routerState.isError) {
      // TODO remade this for general solution as soon as all errors use history state
      next(errorMessagesActions.removeSingleErrorMessage(errorTypes.APPOINTMENT_TYPE_NOT_FOUND));
    }
  }
};
